import { viewportDimensions } from '/helpers/window'
import Modal from '/global/components/modal'
import { setFocus } from '/helpers/misc'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.video`
 * for playing video on pages and in carousels
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

export default function() {

	// trigger playing videos
	let $player
	_.each(document.querySelectorAll('.video-media'), $video => {

		const $button = $video.querySelector('button')
		const $content = $video.querySelector('.video-modal-content')
		const $frame = $video.querySelector('.video-frame')

		// inject youtube api script
		if (!window.sbccYouTubeInjected) {
			window.sbccYouTubeInjected = true
			const script = document.createElement('script')
			script.src = '//www.youtube.com/iframe_api'
			document.querySelector('.hidden-js').appendChild(script)
		}

		$button.addEventListener('click', event => {
			event.preventDefault()

			$button.setAttribute('aria-expanded', 'true')
			$content.removeAttribute('aria-hidden')

			Modal.$body.appendChild($content)
			const $replace = document.createElement('div')
			$replace.id = 'youtube-player'
			$frame.appendChild($replace)
			$player = new YT.Player('youtube-player', {
				width: '560',
				height: '315',
				videoId: $content.dataset.youtubeid,
				// host: 'https://www.youtube.com',
				playerVars: {
					rel: 0,
					showinfo: 0,
					autoplay: 0,
				},
				events: {
					onReady() {
						$player.playVideo()
					},
				},
			})
			// this craziness accounts for aspect ratio changes on different display heights / widths
			const resizeVideo = _.throttle(() => {
				const dimensions = viewportDimensions()
				let modalAspect
				if (dimensions.width < _MEDIA_SMALL) {
					modalAspect = (dimensions.height - 120) / dimensions.width
				} else if (dimensions.width < _MEDIA_MEDIUM) {
					modalAspect = (dimensions.height - 60) / (dimensions.width - 60)
				} else {
					modalAspect = (dimensions.height - 60) / (dimensions.width - 80)
				}
				// aspect ratio = 16:9 = 100 * 9/16
				if (modalAspect < 9 / 16) {
					$frame.style.paddingBottom = (modalAspect * 100) + '%'
				} else {
					$frame.removeAttribute('style')
				}
			}, 100)
			resizeVideo()
			window.addEventListener('resize', resizeVideo)

			Modal.open({
				classes: ['video-modal'],
				backgroundClose: true,
				onClose() {
					const $iframe = document.querySelector('#youtube-player')
					$iframe.parentNode.removeChild($iframe)
					$button.setAttribute('aria-expanded', 'false')
					$content.setAttribute('aria-hidden', 'true')
					$video.appendChild($content)
					window.removeEventListener('resize', resizeVideo)
					setFocus($video)
				},
			})
		})
	})
}
